import axios from 'axios'

/**
 * 公共 API 请求实例（无需登录认证）
 * 用于维护模式检查、公告、平台介绍等公开接口
 * 不添加 Authorization 头，避免过期 token 导致 401 误触发全局登出
 */
const publicService = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// Response interceptor — 公共接口不处理 401 登出逻辑
publicService.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code && res.code !== 200) {
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    const msg = error.response
      ? `请求失败 (${error.response.status})`
      : '网络连接失败，请检查网络'
    return Promise.reject(new Error(msg))
  }
)

export default publicService
